var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 16.5V17.25C13.0002 18.0456 12.6842 18.8087 12.1216 19.3713C11.5589 19.9339 10.7959 20.25 10.0002 20.25C9.20458 20.25 8.44152 19.9339 7.87891 19.3713C7.3163 18.8087 7.00023 18.0456 7.00023 17.25V16.5M18.0477 14.9733C16.844 13.5 15.9941 12.75 15.9941 8.68828C15.9941 4.96875 14.0948 3.64359 12.5315 3C12.3238 2.91469 12.1284 2.71875 12.0651 2.50547C11.7909 1.57219 11.0221 0.75 10.0002 0.75C8.97836 0.75 8.20914 1.57266 7.93773 2.50641C7.87445 2.72203 7.67898 2.91469 7.47133 3C5.90617 3.64453 4.00867 4.965 4.00867 8.68828C4.00633 12.75 3.15648 13.5 1.95273 14.9733C1.45398 15.5836 1.89086 16.5 2.7632 16.5H17.242C18.1096 16.5 18.5437 15.5808 18.0477 14.9733Z",
    stroke: "#2A2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9507e6e95f4b1186b5e0981b88faa545.svg";
export { ForwardRef as ReactComponent };